import {
  ALLOCATION_STATUSES,
  MESSAGE_PRIORITY_TYPES,
  MESSAGE_STATUSES,
  RESERVATION_STATUSES,
  TRAVEL_TYPES,
  TRIP_STATUSES,
} from "@/types/constants/common";
import Chip from "@mui/joy/Chip";
import QuestionMarkOutlinedIcon from "@mui/icons-material/QuestionMarkOutlined";

export const getTripStatusChip = (status: number) => {
  const tripStatus = (TRIP_STATUSES as any)[status];

  if (tripStatus) {
    return (
      <Chip
        sx={{
          bgcolor: tripStatus.bgColor,
          color: tripStatus.color,
        }}
      >
        {tripStatus.name}
      </Chip>
    );
  } else {
    return <></>;
  }
};

export const getTravelTypeChip = (travelType: number) => {
  const travelTypes = (TRAVEL_TYPES as any)[travelType];

  if (travelTypes) {
    return (
      <Chip
        sx={{
          bgcolor: travelTypes.bgColor,
          color: travelTypes.color,
        }}
        size="sm"
      >
        {travelTypes.name}
      </Chip>
    );
  } else {
    return <></>;
  }
};

export const getTravelTypeIcon = (travelType: number) => {
  const travelTypes = (TRAVEL_TYPES as any)[travelType];

  if (travelTypes) {
    return travelTypes.Icon;
  } else {
    return QuestionMarkOutlinedIcon;
  }
};

export const getReservationStatusChip = (status: number) => {
  const reservationStatus = (RESERVATION_STATUSES as any)[status];

  if (reservationStatus) {
    return (
      <Chip
        size="sm"
        sx={{
          bgcolor: reservationStatus.bgColor,
          color: reservationStatus.color,
        }}
      >
        {reservationStatus.name}
      </Chip>
    );
  } else {
    return <>_</>;
  }
};

export const getTripMessageStatusChip = (status: number) => {
  const messageStatus = (MESSAGE_STATUSES as any)[status];

  if (messageStatus) {
    return (
      <Chip
        size="sm"
        sx={{
          bgcolor: messageStatus.bgColor,
          color: messageStatus.color,
        }}
      >
        {messageStatus.name}
      </Chip>
    );
  } else {
    return <>_</>;
  }
};

export const getTripMessagePriorityChip = (status: number) => {
  const messagePriority = (MESSAGE_PRIORITY_TYPES as any)[status];

  if (messagePriority) {
    return (
      <Chip
        size="sm"
        sx={{
          bgcolor: messagePriority.bgColor,
          color: messagePriority.color,
        }}
      >
        {messagePriority.name}
      </Chip>
    );
  } else {
    return <>_</>;
  }
};

export const getAllocationStatusChip = (status: string) => {
  const allocationStatus = (ALLOCATION_STATUSES as any)[status];

  return (
    <Chip
      size="sm"
      sx={{
        bgcolor: allocationStatus.bgColor,
        color: allocationStatus.color,
      }}
    >
      {allocationStatus?.name}
    </Chip>
  );
};
